import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    box: {
        position: 'relative',
        backgroundColor: '#535353',
        minWidth: '20%',
        borderRadius: 24,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingHorizontal: 20,
        maxHeight: '75%',
        overflow: 'hidden',
        maxWidth: '100%',
    },

    imageBackground: {
        position: 'absolute',
        left: 'auto',
        height: 690,
        width: 448,
    },

    title: {
        fontSize: 40,
        fontWeight: '800',
    },

    amountsText: {
        fontSize: 12,
        fontWeight: '600',
    },

    amountsTextRight: {
        fontSize: 12,
        fontWeight: '600',
        textAlign: 'right'
    },

    amountsBeforBarView: {
        alignSelf: 'center',
        width: '95%',
        flexDirection: 'row',
        marginBottom: 12,
    },

    amountsViewRow: {
        alignSelf: 'center',
        width: '95%',
        flexDirection: 'row',
        marginTop: 12
    },

    amountsViewCol: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '95%',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 12,
    },

    amountsViewsLeft: {
        flex: 1
    },

    amountsViewsRight: {
    },

    infosView: {
        alignSelf: 'flex-start',
        width: '100%',
        flexDirection: 'row',
        marginTop: 52
    },

    infosViewValues: {
        flex: 1,
    },

    infoViewRow: {
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginTop: 6,
    },

    infoViewCol: {
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: 6
    },

    titleText: {
        fontSize: 32,
        fontWeight: '700',
        textAlign: 'center'
    },

    infoText: {
        fontSize: 16,
        fontWeight: '700'
    },

    infoValue: {
        fontSize: 16,
        fontWeight: '400',
        textAlign: 'right',
        marginTop: 6
    },

    btnContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },

    btn: {
        width: '100%',
        borderWidth: 1,
        borderRadius: 16,
        borderColor: "rgb(83, 83, 83)"
    },

    btnText: {
        fontSize: 20,
        fontWeight: '600',
        textAlign: 'center'
    },

    line: {
        backgroundColor: '#535353',
        height: 1,
        width: '100%',
        marginBottom: 8,
        marginTop: 107
    },

    textGrey: {
        color: '#535353',
        fontFamily: 'Montserrat',
    },

    textWhite: {
        color: 'white',
        fontFamily: 'Montserrat',
    }
});